<!--
 * @Author: Huangxianlong
 * @Date: 2023-05-16 10:10:31
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2023-06-27 10:49:12
 * @FilePath: \h5\src\components\jt-spin\index.vue
 * @Description: 
-->
<template>
  <Spin fix>
    <Icon
      type="ios-loading"
      size="18"
      class="demo-spin-icon-load"
    ></Icon>
    <div>{{title}}</div>
  </Spin>
</template>
<script>
export default {
  name: "JTSpin",
  props: {
    title: {
      type: String,
      default: '数据加载中...'
    }
  }
};
</script>

<style lang="less" scoped>
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
</style>


// WEBPACK FOOTER //
// src/components/jt-spin/index.vue